<template>
    <v-container
            fluid fill-height align-content-start justify-start
            class="pa-0"
    >

        <code-view :code="content" :lang="lang"></code-view>
        <v-btn fab fixed bottom right class="mr-3" color="blue" dark
               @click="copyToClipboard">
            <v-icon>mdi-content-copy</v-icon>
        </v-btn>
    </v-container>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";
    import CodeView from "@/components/shared/CodeView";
    import {TRANSACTION_NS} from "@/store/modules/transaction/constants";
    import {NOTIFICATION_NS} from "@/store/modules/notification/constants";

    export default {
        name: "PoslogDisplayComponent",
        components: {CodeView},
        computed: {
            ...mapGetters(TRANSACTION_NS, [
                'content',
                'lang',
                'showVersionWarning',
                'transactionId',
                'anonymized'
            ])
        },
        methods: {
            ...mapActions(NOTIFICATION_NS, [
                'addNotification'
            ]),
            copyToClipboard() {
                navigator.clipboard.writeText(this.content);

                this.addNotification({
                    message: 'Content copied to clipboard!'
                });
            },
            moveToLastVersion: function() {
                const params = {
                    transactionId : this.transactionId,
                    messageDateTime: null,
                    version: null,
                    view: 'xml',
                    anonymized : this.anonymized ? 'anonymized' : 'raw'
                }

                this.$router.replace({
                    name: 'transactionView',
                    params
                });
            }
        }

    }
</script>